import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
// import qs from "qs";

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function getProductDiscussion(params) {
	return client.get("product-discussion/data", {
		params: params,
	});
}

export default {
	getProductDiscussion,
};